// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bell16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell': IconBell;
    }
}

/**
 * The icon component for the 'bell' icon
 */
export class IconBell extends Icon {
    public constructor() {
        super(bell16X16);
    }
}

registerIcon('icon-bell', IconBell);
export const iconBellTag = 'nimble-icon-bell';
